import { ApiRoute } from 'api-base-refrence';
import { InformationApiRoute } from './information.api';
import { NestjsPageFilter } from 'nestjs-model-utility';
import { InformationModel } from 'src/domains/charts/model/information/information.model';

export class InformationAbsorbtionChart extends ApiRoute {
  static apiName = 'report__customer_segmentation';
  static parent = InformationApiRoute;
  static urlPattern(
    filter?: NestjsPageFilter<keyof InformationModel.absorbtionChart>,
  ) {
    return '/absorption-number-chart';
  }
}
